import { useState, useEffect } from 'react'

let audioShort
let audioLong

export default function useAudioPlayer() {
  const [duration, setDuration] = useState()
  const [curTime, setCurTime] = useState()
  const [playing, setPlaying] = useState(false)
  const [clickedTime, setClickedTime] = useState()

  useEffect(() => {
    const spoken = document.getElementById('spoken')
    const bgMusic = document.getElementById('bgMusic')
    const singleAudio = document.getElementById('singleAudio')

    if (spoken && bgMusic) {
      if (spoken.duration > bgMusic.duration) {
        audioShort = bgMusic
        audioLong = spoken
      } else {
        audioShort = spoken
        audioLong = bgMusic
      }
    }

    if (singleAudio) {
      audioLong = singleAudio
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [audioShort, audioLong])

  useEffect(() => {
    curTime >= audioLong?.duration && setPlaying(false)

    if (audioShort && curTime >= audioShort?.duration) {
      audioShort.pause()
      audioShort.currentTime = 0
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [curTime, audioShort])

  useEffect(() => {
    // state setters wrappers
    const setAudioData = () => {
      setDuration(audioLong.duration)
      setCurTime(audioLong.currentTime)
    }

    const setAudioTime = () => setCurTime(audioLong.currentTime)

    // DOM listeners: update React state on DOM events
    audioShort && audioShort?.addEventListener('loadeddata', setAudioData)
    audioLong?.addEventListener('loadeddata', setAudioData)

    audioShort && audioShort?.addEventListener('timeupdate', setAudioTime)
    audioLong?.addEventListener('timeupdate', setAudioTime)

    // React state listeners: update DOM on React state changes
    if (playing) {
      audioLong.play()
      audioShort &&
        (curTime >= audioShort?.duration
          ? audioShort.pause()
          : audioShort.play())
    } else {
      audioLong?.pause()
      audioShort && audioShort?.pause()
    }

    if (clickedTime && clickedTime !== curTime) {
      audioShort && (audioShort.currentTime = clickedTime)
      audioLong.currentTime = clickedTime
      setClickedTime(null)
    }

    // effect cleanup
    return () => {
      audioShort && audioShort?.removeEventListener('loadeddata', setAudioData)
      audioLong?.removeEventListener('loadeddata', setAudioData)
      audioShort && audioShort?.removeEventListener('timeupdate', setAudioTime)
      audioLong?.removeEventListener('timeupdate', setAudioTime)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [playing, clickedTime, curTime, audioShort, audioLong])

  return {
    curTime,
    duration,
    playing,
    setPlaying,
    setClickedTime
  }
}
